import { colors } from '@material-ui/core'

import constants from 'constants/index'

const chipStatusColor = (status) => {
  return (
    (status && constants.settings.FINANCIAL_CHIP_STATUS_COLOR[status]) ||
    colors.blueGrey[800]
  )
}

export default chipStatusColor
